import { ApplicationRoutes } from "./routes/Routes";

export default function App() {
  return (
    <>
      <ApplicationRoutes></ApplicationRoutes>
    </>
  );
}
